export enum EnvName {
  DEV = 1,
  PROD,
}
